import style from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark";
import styled, {keyframes} from "styled-components";

/* icons.tsx는 블로그 페이지 전체에서 사용하는 아이콘 관리용 컴포넌트 */

const heartMoving = keyframes`
    0% {
        transform: translateY(-5px) rotate(10deg);
    }

    0% {
        transform: translateX(1px) rotate(20deg) scale(1.2);
    }

    50% {
        transform: translateX(1px) rotate(10deg) scale(1.1);
    }

    100% {
        transform: translateY(-1px);
    }
`;

// 기본 아이콘 container 틀
const Containier = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    color: ${props => props.theme.CONTENT.SUMMARY_COLOR};

    margin-left: auto;

    & > svg:hover {
        color: #ff6f6f;
        border-radius: 50%;
    }
`;

export const LikeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.9rem;
    color: black;
    margin-left: auto;

    cursor: pointer;

    &:hover {
        color: #3b82f6; // 호버 시 파란색
    }
`;

export const ViewIconContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.9rem;
    color: ${props => props.theme.CONTENT.SUMMARY_COLOR};

    margin-left: auto;
`;

export const HeartIconContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.9rem;
    color: black; // 좋아요 아이콘과 동일한 색상
    margin-left: 1rem;
    color: ${props => props.theme.CONTENT.SUMMARY_COLOR};

    & > svg:active {
        animation: ${heartMoving} 0.3s;
    }

    cursor: pointer;
`;

export const TagIconContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    margin-right: auto;
`;

export const InfoIconContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3rem;
    margin-right: auto;
`

export const MenuIconContainer = styled(TagIconContainer)`
    color: ${props => props.theme.CONTENT.SUMMARY_COLOR};
`;

export const TrashIconContainer = styled(Containier)`
    cursor: pointer;
`;

export const ModifyIconContainer = styled(Containier)`
    cursor: pointer;
`;
export const CalenderIconContainer = styled(Containier)`
    color: white;
`;

export function ViewIcon() {
    return <>
    <svg 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        {/* 눈 모양 아이콘 (View) */}
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
        <circle cx="12" cy="12" r="3"></circle>
    </svg>
    </>
}

export function LikeIcon() {
    return <>
    {/* 깔끔한 단색 Thumbs Up SVG */}
    <svg 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
    </svg>
    </>
}

export function HeartIcon() {
    return (
        <>
        <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="#ff5773" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
        </>
    );
}

export function TrashIcon() {
    return (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        >
        <path d="M3 6h18"></path>
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        <line x1="10" y1="11" x2="10" y2="17"></line>
        <line x1="14" y1="11" x2="14" y2="17"></line>
        </svg>
    );
}

export function TagIcon({ size = 16, color = "currentColor" }) {
    return (
        <>
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 24 24" 
            fill="currentColor" /* 내부를 현재 색상으로 채움 */
            /* stroke는 필요 없으므로 제거하여 더 깔끔하게 만듭니다. */
        >
            {/* Compound Path: 
              1. 태그의 전체 외곽선 (M20.59...)
              2. 반시계 방향으로 그려진 원 (M7, 5a2...) -> 이 부분이 뚫립니다.
            */}
            <path d="M20.59,10.59l-8.59-8.59A2,2,0,0,0,10.59,2H2V10.59a2,2,0,0,0,.59,1.41l8.59,8.59a2,2,0,0,0,2.82,0L20.59,13.41A2,2,0,0,0,20.59,10.59ZM7,9a2,2,0,1,1,2-2A2,2,0,0,1,7,9Z"></path>
        </svg>
        </>
    );
}

export function ModifyIcon() {
    return (
        <>
        {/* 깔끔한 연필 모양의 Modify SVG */}
        <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
        </>
    );
}

export function CalendarIcon() {
    return (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
        <line x1="16" y1="2" x2="16" y2="6"></line>
        <line x1="8" y1="2" x2="8" y2="6"></line>
        <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
    );
}

export function MenuIcon() {
    return (
        <>
            <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                {/* 메뉴 아이콘 (Hamburger Menu) */}
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
        </>
    );
}

export function GithubIcon() {
    return (
        <>
            <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="currentColor" /* 속을 currentColor로 채움 */
                stroke="none"      /* 테두리 없앰 */
            >
                {/* GitHub 정교한 로고 path (속 채움) */}
                <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"></path>
            </svg>
        </>
    );
}

export function LinkedinIcon() {
    return (
        <>
            <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="currentColor" /* 속을 currentColor로 채움 */
                stroke="none"      /* 테두리 없앰 */
            >
                {/* LinkedIn 사각형 전체를 채우는 path */}
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
            </svg>
        </>
    );
}

export function AdminShieldIcon() {
    return (
        <>
            <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                {/* 관리자 아이콘 (User + Shield) */}
                <path d="M20 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M1 21v-2a4 4 0 0 1 4-4h5a4 4 0 0 1 4 4v2"></path>
                <circle cx="7.5" cy="7" r="4"></circle>
                <path d="M22 9c0 5-3.5 7.5-3.5 7.5S15 14 15 9V5l3.5-1.5L22 5v4z"></path>
            </svg>
        </>
    );
}

export function VisitorIcon() {
    return (
        <>
            <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                {/* 외부인 아이콘 (User + Log-in Arrow) */}
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="8.5" cy="7" r="4"></circle>
                <polyline points="15 3 20 3 20 8"></polyline>
                <line x1="14" y1="9" x2="20" y2="3"></line>
            </svg>
        </>
    );
}

export function NoSearchResultIcon() {
    return (
        <>
            <svg 
                width="64" /* 결과 없음 화면이므로 크게 설정 (조절 가능) */
                height="64" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                style={{ color: '#rgba(0, 0, 0, 0.5)' }} /* 추천: 연한 회색 */
            >
                {/* 검색 결과 없음 아이콘 (돋보기 + X) */}
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="8" y1="8" x2="14" y2="14"></line>
                <line x1="14" y1="8" x2="8" y2="14"></line>
            </svg>
        </>
    );
}

export function SearchIcon({ size = 24, color = "currentColor" }) {
    return (
        <>
            <svg 
                width={size} 
                height={size} 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                style={{ color: '#rgba(0, 0, 0, 0.5)' }} /* 추천: 연한 회색 */
            >
                {/* 검색 결과 없음 아이콘 (돋보기) */}
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
        </>
    );
}

export function InfoIcon({ size = 16, color = "currentColor" }) {
    return (
        <>
            <svg 
                width={size} 
                height={size} 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                {/* 정보 아이콘 (Circle Info) */}
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
        </>
    );
}

export function SunIcon({ size = 24, color = "currentColor" }) {
    return (
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={color} 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            {/* 태양 아이콘 */}
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
        </svg>
    );
}

export function MoonIcon({ size = 24, color = "currentColor" }) {
    return (
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={color} 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            {/* 달 아이콘 (초승달) */}
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
    );
}

export function PlusIcon({ size = 20, color = "currentColor" }) {
    return (
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={color} 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            {/* 플러스 아이콘 (+) */}
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
    );
}